module.exports = __webpack_public_path__ + "img/header-1.ad3e0782.svg";